/**
 * Header
 * @var header
 */
export default class Header {
  /**
   * Constructor
   */
  constructor() {
    this.body = document.querySelector('body');
    this.searchBtnOpen = document.querySelector('.btn--search.js-btn-open');
    this.searchBtnClose = document.querySelector('.btn--search.js-btn-close');
    this.searchForm = document.querySelector('.form__search');
    this.searchBar = document.querySelector('.search__input');
    this.burgerBtn = document.querySelector('.btn--burger');
    this.submenuBtn = document.querySelectorAll('.menu__link--hassubmenu');

    // declare here to remove event listener
    this.listenClickbodyFunction = this.listenClickbody.bind(this);
  }

  /**
   * Init
   */
  init() {
    this.hasBreakpointChanged();

    this.searchBtnOpen.addEventListener('click', e => {
      e.preventDefault();
      this.openSearch();
    });
    this.searchBtnClose.addEventListener('click', e => {
      e.preventDefault();
      this.closeSearch();
    });

    this.burgerBtn.addEventListener('click', this.handleMenu.bind(this), false);

    this.submenuBtn.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        Header.handleSubmenu(item);
      });
    });

    this.closeOnresize();
  }

  /**
   * Open search
   */
  openSearch() {
    this.searchForm.classList.add('is-active');
    this.searchBtnClose.classList.remove('display-none');
    this.searchBtnOpen.classList.add('display-none');
    this.searchBar.value = '';
    this.searchBar.focus();
  }

  /**
   * Close search
   */
  closeSearch() {
    this.searchForm.classList.remove('is-active');
    this.searchBtnClose.classList.add('display-none');
    this.searchBtnOpen.classList.remove('display-none');
  }

  /**
   * Open/Close menu in mobile
   */
  handleMenu() {
    this.body.classList.toggle('open-menu');

    if (this.body.classList.contains('open-menu')) {
      document.addEventListener('click', this.listenClickbodyFunction);
    }
  }

  /**
   * Handle Submenu
   */
  static handleSubmenu(element) {
    element.classList.toggle('submenu--open');
  }

  /**
   * On body click
   */
  listenClickbody(e) {
    if (!e.target.closest('header')) {
      this.handleMenu();
      document.removeEventListener('click', this.listenClickbodyFunction);
    }
  }

  /**
   * Close menu on resize
   */
  closeOnresize() {
    window.addEventListener('resize', () => {
      if (this.hasBreakpointChanged()) {
        this.closeSearch();

        if (this.body.classList.contains('open-menu')) {
          this.handleMenu();
        }
      }
    });
  }

  /**
   * has breakpoint changed
   *
   * @returns bool true if breakpoint has changed, else false
   */
  hasBreakpointChanged() {
    const newBeakpoint = window
      .getComputedStyle(document.querySelector('body'), ':after')
      .getPropertyValue('content')
      .split('"')
      .join('');

    if (this.breakpoint !== newBeakpoint) {
      this.breakpoint = newBeakpoint;
      return true;
    }

    return false;
  }
}
